module.exports = __webpack_public_path__ + "img/logo2.e00bd87b.png";